export * from './post-start-tour.component';
export * from './post-start-tour.component.module';